import { toast } from 'react-toastify';
import './toastSpinner.css'
import 'react-toastify/dist/ReactToastify.css';
import 'react-toastify/dist/ReactToastify.min.css';

const showToasterMessage = async (message, type) => {
    if (type === 'success') {
        toast.success(message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            theme: "colored",
        });
    } else if (type === 'error') {
        toast.error(message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
            theme: "colored",
        });
    } else if (type === 'warning') {
        toast.warn(message, {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
            theme: "colored",
        });
    } else if (type === 'loading') {
        // Custom JSX content with a loader spinner
        return toast.info(
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div class="loader">
                    <div class="bar1"></div>
                    <div class="bar2"></div>
                    <div class="bar3"></div>
                    <div class="bar4"></div>
                    <div class="bar5"></div>
                    <div class="bar6"></div>
                    <div class="bar7"></div>
                    <div class="bar8"></div>
                    <div class="bar9"></div>
                    <div class="bar10"></div>
                    <div class="bar11"></div>
                    <div class="bar12"></div>
                </div>
                <span>{message || 'Please wait while we process the transcription...'}</span>
            </div>,
            {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                theme: "colored",
                toastId: "loader-toast",
            }
        );
    }
};

export default showToasterMessage;
